<div class="form-check">
  <label for="is_conditional" class="form-check-label" translate>Is Conditional?</label>
  <input type="checkbox" class="form-check-input" [(ngModel)]="component.element.conditional" id="is_conditional" />
</div>
<div class="row mt-2" *ngIf="component.element.conditional">
  <div class="col-6">
    <div class="row mb-2">
      <label class="col-sm-12" translate>Ref. Field name</label>
      <div class="col-sm-12">
        <input type="text" name="field_name" [(ngModel)]="component.element.ref_field_name"
          class="form-control form-control-sm">
      </div>
    </div>
  </div>
  <div class="col-2 d-flex align-items-center">
    ==
  </div>
  <div class="col-4">
    <div class="form-row">
      <label class="col-sm-12" translate>Value</label>
      <div class="col-sm-12 mb-2">
        <select name="ref_field_value" class="form-select form-select-sm" id="ref_field_value"
          [(ngModel)]="component.element.ref_field_value">
          <option value=true>True</option>
          <option value=false>False</option>
          <option value=1>1</option>
        </select>
      </div>
    </div>
  </div>
</div>